module.exports = __webpack_public_path__ + "img/image-input.b857e780.svg";